import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Breadcrumb.css';

import {
  ROUTE_LABELS,
  BLOG_TITLES,
  JOB_TITLES,
} from './breadcrumb.config';

const formatLabel = (seg) =>
  ROUTE_LABELS[seg] ||
  seg.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());

const getDynamicLabel = (seg, prevSeg) => {
  if (prevSeg === 'blogs') return BLOG_TITLES[seg] || 'Article';
  if (prevSeg === 'careers') return JOB_TITLES[seg] || 'Position Details';
  return null;
};

const Breadcrumb = ({ homeLabel = 'Home' }) => {
  const { pathname } = useLocation();

  const segments = useMemo(
    () => pathname.split('/').filter(Boolean),
    [pathname]
  );

  const breadcrumbItems = useMemo(() => {
    return segments.map((seg, i) => {
      const prevSeg = i > 0 ? segments[i - 1] : null;

      const dynamicLabel = getDynamicLabel(seg, prevSeg);
      const label = dynamicLabel || formatLabel(seg);

      return {
        label,
        path: '/' + segments.slice(0, i + 1).join('/'),
        isLast: i === segments.length - 1,
        isDynamic: Boolean(dynamicLabel),
      };
    });
  }, [segments]);

  if (!segments.length) return null;

  return (
    <div className="breadcrumb-container">
      <div className="museum-wrap">
        <nav className="breadcrumb-nav" aria-label="Breadcrumb">
          
          <Link to="/" className="breadcrumb-link">
            {homeLabel}
          </Link>

          {breadcrumbItems.map((item, i) => (
            <React.Fragment key={`${item.label}-${i}`}>
              <span className="breadcrumb-separator">
                <i className="fas fa-chevron-right" />
              </span>

              {item.isLast ? (
                <span className="breadcrumb-current">
                  {item.label}
                </span>
              ) : (
                <Link to={item.path} className="breadcrumb-link">
                  {item.label}
                </Link>
              )}
            </React.Fragment>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default Breadcrumb;